module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.2df512d0.png";